
// const saleDataFromSaleStore = store. useSelector((state: any) => state.saleDataStore?.saleData || {});
import { exec, isAndroid, isElectron, sendDataToApp } from "utils/nativeHooks";
import store from "../redux-store/index";
import { arrayToMap, getChannelDefData } from "./catalogueHelpers";
import * as htmlToImage from 'html-to-image';
import QRCode from "qrcode";
import JsBarcode from "jsbarcode";
import { isEmpty } from "lodash";
import { getLocalStorage } from "utils";
import { pollForTickets } from "utils/polling";
import { getUniqueListByKey, handleWarningModal, isPineLabDevice } from "./commonHelpers";
import { RISTA_API_URL, RISTA_COMMON_URL } from "config";
import { updateToastInfo } from "redux-store/slices/CheckoutSlice";
import { getErrorMessage } from "utils/pos_errors";
import { getSelectedChannel, updatePunchedNamePrintContent } from "./saleHelpers";
import { getLSRequestPayloadData, getMasterDomain, isSlave } from "./localServer";
import { CLOSED, LOCALSTORAGE_KEYS, MULTI_LANGUAGE_TEMPLATE_NAME, TICKET_PRINT_STATUS_TYPES } from "utils/constants";
import { isOffline } from "facade/ServiceFacade";
import { updateAllTicketsPrintStatus } from "./OfflineHelper";
import { USBPrinter, getAddedBlePrintersList, getLocalStorageWithParse } from "utils/localStorage";
import { DEFAULT_PRINTER_MSG, DEFAULT_PRINTER_OBJ, MIN_NW_APP_VERSION_SUPPORTED, NW_APP_EVENT_ACTIONS, NW_APP_EVENT_KEYS, NW_APP_LATEST_STABLE_VERSION, PRINTER_TYPES_KEYS, REACT_NATIVE_APP_EVENTS } from "data/constants";
import moment from "moment";
import { updateAdhocTables } from "./adhocTableHelpers";
import { printKOTSlice } from "redux-store/slices/TableViewSlice";
import { ToastNotifyError, ToastNotifyInfo } from "commonComponents/ToastNotify";
import { getVersionNumber } from "./versionHelper";
import { catalogHelpers } from "@dotpe/rista-pos-common";
import { getPaymentMethods } from "./paymenthelper";
import md5 from "md5";

export function openCashDrawer(printer) {
  let printerVo = printer;
  let cmd = 'ESC p 0 25 250';
  if ((printerVo?.label && printerVo?.label?.toLowerCase() === 'innerprinter') &&
    (printerVo?.printerType === 'BLUETOOTH')) {
    cmd = 'SPR 20 0 0 0';
  }
  if (isElectron()) {
    window.electronAPI.printer.print(cmd, printerVo);
  } else {
    exec(NW_APP_EVENT_KEYS.printer, NW_APP_EVENT_ACTIONS.printer.print, [cmd, printerVo]);
  }
}

export async function printSale(saleData, printer, copies = 1, type = '', isAutoPrintBills = false, isManual = false) {
  let printDeviceId =
    store.getState().catalogStore?.posSettings?.tickets?.printDeviceId,
    pollingChannles =
      store.getState().catalogStore?.posSettings?.tickets
        ?.pollingChannelDefIds || [],
    localServer = store.getState().catalogStore?.posSettings?.localServer || {};

  const isKotTicket = !!saleData?.ticketNumber; // tells whether it is bill or ticket

  const hasMasterPollingOn = // tells if master device has polling on
    printDeviceId &&
    localServer?.deviceIdentifier &&
    printDeviceId === localServer.deviceIdentifier &&
    pollingChannles?.includes(saleData?.channelDefId);

  const printBillFromMaster =
    getLocalStorageWithParse(LOCALSTORAGE_KEYS.printBillFromMaster) || false;

  const printFromMaster = isSlave() && printBillFromMaster && !isKotTicket;

  console.log("===============ticketGroup    INSIDE print sale", copies);
  try {
    if (printer && !Object.keys(printer)?.length && !isPineLabDevice() && !printFromMaster) {
      handleWarningModal(DEFAULT_PRINTER_MSG);
    }
    let businessType = store.getState().businessStore?.businessData?.businessType;
    let billTemplate = store.getState().businessStore?.businessData?.billTemplate;
    let ticketSettings = store.getState().catalogStore?.posSettings?.tickets,
      channelDefData = arrayToMap(store.getState().catalogStore?.channelDef, "mid");
    saleData = structuredClone(saleData);
    const branchId = store.getState()?.businessStore?.businessData?.branchId;
    //replace shortName with punchedName.
    saleData.saleItems = [...updatePunchedNamePrintContent(saleData.saleItems)];
    if (isAutoPrintBills && saleData?.channelDefId && channelDefData?.[saleData?.channelDefId]) {
      let selectedChannelData = channelDefData?.[saleData?.channelDefId];
      selectedChannelData = catalogHelpers.handleChannelVariant(selectedChannelData, branchId);
      copies = selectedChannelData?.billPrintCopies;
    }
    console.log(channelDefData?.[saleData?.channelDefId], "===========copies=======", copies)
    if (saleData.mid) {
      if (!billTemplate?.skipRistaQuote) {
        saleData.showRistaQuote = true;
      }
    }
    let printParams = {
      maxChars: printer?.printWidth ?? 46,
      billTemplate: billTemplate
        ? structuredClone(billTemplate)
        : "",
      posPreferences: store.getState().catalogStore?.posSettings,
    };
    if (type && type === "giftreceipt") {
      printParams.templateOptions = { compact: true, title: "Gift Receipt" };
    }
    if (!saleData?.mid) {
      printParams.templateOptions = printParams?.templateOptions || {};
      printParams.templateOptions.fontSize = ticketSettings?.fontSize
        ? ticketSettings?.fontSize
        : "regular";
      printParams.templateOptions.compact = true;
      printParams.templateOptions.pinSupport = ticketSettings?.pinSupport;
    }
    if (billTemplate?.signatureImageId !== saleData?.signatureImageId) {
      delete printParams?.signatureBitmap;
    }
    printParams.businessType = businessType;

    try {
      if (isEmpty(saleData.customerInfo)) {
        delete saleData.customerInfo;
        if (isEmpty(saleData?.deliveryInfo?.customerInfo)) {
          delete saleData?.deliveryInfo?.customerInfo;
        }
        if (saleData?.deliveryInfo && isEmpty(saleData?.deliveryInfo?.contactInfo)) {
          delete saleData?.deliveryInfo.contactInfo;
        }
      }
      if (isEmpty(saleData?.deliveryInfo)) {
        delete saleData.deliveryInfo;
      }
      if (isEmpty(saleData?.serviceLabel)) {
        delete saleData.serviceLabel;
      }
    } catch (error) {
      console.log('error: ', error)
    }
    if (checkBillReprint(saleData))
      saleData.billTitle = saleData.billTitle + "(Reprint)";
    if (saleData && printParams) {
      // console.log(printParams, "sss");
      if (isAndroid()) {
        console.log("=====isAndroid Printe sale reached=")
        saleData.printQRCode = false;
        saleData.footerOnOpen = false;
        saleData.billFooter = "";
        saleData.signatureImageId = "";
        if (saleData.billHeader)
          saleData.billHeader.imageDataId = "";
        let printData = window.RL?.bill?.getPrintContent(saleData, printParams);
        if (isPineLabDevice()) {
          sendDataToApp({
            eventName: REACT_NATIVE_APP_EVENTS.pinelabsPrintBill,
            data: saleData,
            // printParams,
            printerDetails: printer,
          });
        } else {
          sendDataToApp({
            eventName: REACT_NATIVE_APP_EVENTS.printBill,
            // data: saleData,
            data: printData,
            // printParams,
            printerDetails: printer,
          });
        }
        console.log('Trying Test Mobile', printData);
      } else {
        console.log(channelDefData?.[saleData?.channelDefId], "===========copies=======", copies)
        let sale = structuredClone(saleData);
        let paymentMethods = getPaymentMethods()
        let shouldOpenCashDrawer = true; // default behaviour to maintain backward compatibility
        if (paymentMethods && sale.paymentModes?.length > 0) {
          /*
            check across ALL payment modes of the sale -
            if any of them has disableCashDrawerToggleField === 0, open the cash drawer
          */
          var paymentMethodsMap = arrayToMap(paymentMethods, "mode");
          shouldOpenCashDrawer = sale.paymentModes.some((mode) => {
            var paymentMode = (paymentMethodsMap
              ? paymentMethodsMap[mode]
              : paymentMethods.find((method) => method.mode === mode)) || {};
            return (
              Object.prototype.hasOwnProperty.call(paymentMode, "disableCashDrawerToggleField") &&
              paymentMode.disableCashDrawerToggleField === 0
            );
          });
        } else if (!sale.paymentModes?.length) {
          shouldOpenCashDrawer = false;
        }
        if (!isKotTicket && shouldOpenCashDrawer && !checkBillReprint(saleData) && !isManual) {
          openCashDrawer(printer);
        }
        if (billTemplate?.showPhoneNumber) {
          sale.showPhoneNumber = true;
        }
        const printHtmlReceipt = printParams?.billTemplate?.templateName === MULTI_LANGUAGE_TEMPLATE_NAME;
        if(printHtmlReceipt) {
          await updateQrAndBarcodeData(sale, printParams);
          getPrintDataFromHtml(sale, printParams, printer?.printWidth).then((printDataArr) => {
            for (const printData of printDataArr) {
              console.log("========html printData====", "type", typeof printData, printData);
              performPrintAction(printData, { ...printer, contentType: 'RAW' }, copies, printFromMaster);
            }
           }).catch((err) => {
            console.log("Error in getting print data from html", err);
           });
          return;
        } else {
          let printData = window.RL?.bill?.getPrintContent(sale, printParams);
          console.log("========printData====", "type", typeof printData, printData);
          performPrintAction(printData, printer, copies, printFromMaster);
        }

      }
      // return printData
    }
  } catch (error) {
    console.log("err:", error);
    return error;
  }
}

export function checkBillReprint(saleData) {
  if (saleData?.printLog && saleData.printLog.length > 1 && saleData.printLog[saleData.printLog.length - 1].auto !== true) {
    return true;
  }
  return false;
}

export function getPrintersForTicket(saleData) {
  let allPrintersList = store.getState().printerStore?.allPrinters || [],
    localPrintersList = store.getState().printerStore?.localPrinters || [],
    blePrinterList = getAddedBlePrintersList();

  let allPrinters = [
    ...allPrintersList,
    ...localPrintersList,
    ...blePrinterList,
  ];

  let printersMap = arrayToMap(allPrinters, "mid");
  let printers = [];
  let printer;
  let resourceGroupId = "noresourcegroup";
  let posSettings = store.getState().catalogStore?.posSettings;
  try {
    if (!Object.keys(posSettings?.tickets)?.length) {
      return;
    }
    let tickets = posSettings?.tickets;
    if (saleData?.serviceLabel && saleData?.serviceLabel?.resourceGroupId) {
      resourceGroupId = saleData.serviceLabel.resourceGroupId;
    }
    console.log(tickets, "===============ticketGroup tickets");
    if (tickets && !tickets?.groups?.length) {
      printer = store.getState().printerStore?.defaultPrinter || {};
      if (Object.keys(printer)?.length) {
        printers.push({ printer: printer });
      }
    } else if (saleData?.groupName && tickets?.groups?.length) {
      tickets.groups.forEach(function (ticketGroup) {
        console.log(ticketGroup, "===============ticketGroup saledata", saleData);
        if (ticketGroup?.name === saleData?.groupName && ticketGroup?.printers?.length) {
          printers = printers.concat(processPrinterFromKOT(ticketGroup.printers, printersMap, resourceGroupId, saleData));
        }
      });

      // case: if saleData.groupName does not exist in the tickets.groups
      if (!printers?.length) {
        printers = printers.concat(handleDefaultKOTGroup(tickets, printersMap, resourceGroupId, saleData));
      }
    }
    console.log("===============ticketGroup  printers", printers);
    return printers;
  } catch (error) {
    console.log("err:", error);
    return error;
  }
}

function getPrinterById(printerId, printersMap) {
  if (printerId === PRINTER_TYPES_KEYS.defaultPrinter) {
    return store.getState().printerStore?.defaultPrinter || {};
  }
  if (printerId === PRINTER_TYPES_KEYS.USB_PRINTER) {
    return USBPrinter();
  }
  return printersMap?.[printerId] || {};
}

function shouldSkipTicketGroupPrinter(ticketGroupPrinter, resourceGroupId, saleData) {
  const hasInvalidResourceGroup =
    ticketGroupPrinter?.resourceGroupIds?.length &&
    (!resourceGroupId || !ticketGroupPrinter.resourceGroupIds.includes(resourceGroupId));

  const isInvalidItemType =
    (ticketGroupPrinter.itemType === "Regular" && saleData.isBackOrderTicket) ||
    (ticketGroupPrinter.itemType === "Back Order" && !saleData.isBackOrderTicket);

  return hasInvalidResourceGroup || isInvalidItemType;
}

function processPrinterFromKOT(inputPrinters, printersMap, resourceGroupId, saleData) {
  const result = [];
  for (const ticketGroupPrinter of inputPrinters) {
    if (!shouldSkipTicketGroupPrinter(ticketGroupPrinter, resourceGroupId, saleData)) {
      const printer = getPrinterById(ticketGroupPrinter.printerId, printersMap);
      if (!isEmpty(printer)) {
        result.push({
          printer,
          copies: ticketGroupPrinter?.copies || 1,
        });
      }
    }
  }
  return result;
}

function handleDefaultKOTGroup(tickets, printersMap, resourceGroupId, saleData) {
  const defaultKOTGroup = tickets.groups?.find(group => group.defaultKOTGroup === true);

  if (defaultKOTGroup?.printers?.length) {
    return processPrinterFromKOT(defaultKOTGroup.printers, printersMap, resourceGroupId, saleData);
  }

  const printer = getPrinterById(PRINTER_TYPES_KEYS.defaultPrinter, printersMap);
  return !isEmpty(printer) ? [{ printer }] : [];
}

//======================================

export function printKOT(ticketDataArr, isManualPrint = false) {
  const printAggregatedKotOnMFROnly = store.getState().catalogStore?.posSettings?.printAggregatedKotOnMFROnly;
  console.log("ticketsData", ticketDataArr);
  let finalTicketsArr = [];
  const saleId = ticketDataArr[0]?.saleId;
  ticketDataArr?.forEach(function (ticketData) {
    if (ticketData?.isAggregatedTicket && printAggregatedKotOnMFROnly && !isManualPrint) {
      return;
    }
    let printers = getPrintersForTicket(ticketData);
    if (!printers?.length) {
      ToastNotifyError(getErrorMessage("UI_ERR_SELECT_PRINTER_FROM_POS"));
      return;
    }
    console.log("===============ticketGroup   isManualPrint", isManualPrint, ticketData);
    if (!isManualPrint) {
      if (ticketData?.printStatus === "Pending" || ticketData?.printStatus === "Failed") {
        finalTicketsArr.push(ticketData);
      }
    } else {
      finalTicketsArr.push(ticketData);
    }
  });
  console.log("===============ticketGroup finalTicketsArr", finalTicketsArr);

  if (finalTicketsArr.length) {
    let ticketInfos = [];
    for (let i = 0; i < finalTicketsArr.length; i++) {
      ticketInfos.push({
        ticketNumber: finalTicketsArr[i]?.ticketNumber,
        printStatus: TICKET_PRINT_STATUS_TYPES.COMPLETED,
      });
    }
    let payload = {
      id: saleId,
      ticketInfos,
    };

    if (isManualPrint) {
      ToastNotifyInfo("Printing KOTs...");
      printKOTsOneByOne(finalTicketsArr);
    } else if (isOffline()) {
      updateAllTicketsPrintStatus({
        ...payload,
        cb: (res, err) => {
          if (!res?.code && !err) {
            printKOTsOneByOne(finalTicketsArr);
          }
        },
      });
    } else {
      // let updateTicketStatusResponse = updatePrintStatus({ticketInfos}, saleId);
      // updateTicketStatusResponse.then(() => printKOTsOneByOne(finalTicketsArr));
      store.dispatch(printKOTSlice({
        ...payload,
        callback: (response) => {
          if (response?.branchId || response?.tickets) {
            printKOTsOneByOne(finalTicketsArr);
          }
        },
      }));
    }
  }
}

// this function prints KOTs one by one
function printKOTsOneByOne(ticketsArr) {
  ticketsArr?.forEach((ticket) => {
    let printers = getPrintersForTicket(ticket);
    for (let i = 0; i < printers?.length; i++) {
      printSale(ticket, printers[i]?.printer, printers[i]?.copies, 1);
    }
  });
}

//======================================

export function getTickets(saleData, tickets, auto) {
  let ticketData,
    saleItems = [],
    saleItem,
    itemOptions,
    ticketDataArr = [],
    billHeader,
    createdBy,
    contactInfo;
  let ticketSettings = store.getState().catalogStore?.posSettings?.tickets || {};
  let groups = ticketSettings.groups;
  if (isEmpty(tickets)) {
    return [];
  }

  let printTemplate = ticketSettings.printTemplate || {};
  if (tickets.length)
    tickets?.forEach(function (ticket) {
      ticketData = {};
      saleItems = [];
      createdBy = ticket.createdBy;
      //To be used for processing
      ticketData.saleId = saleData?.mid;
      ticketData.printed = ticket?.printed;
      ticketData.printStatus = ticket?.printStatus;
      ticketData.ticketNumber = ticket?.ticketNumber;
      ticketData.sourceInfo = saleData?.sourceInfo;
      if (ticket.ticketStatus !== "Cancelled") {
        ticketData.ticketNote1 = ticket?.ticketNote1;
        ticketData.ticketNote2 = ticket?.ticketNote2;
      }

      //Do not print items for cancelled sale tickets.
      if (isEmpty(ticket?.saleItems)) {
        saleData?.saleItems?.forEach(function (item) {
          if (item?.ticketNumber === ticket?.ticketNumber) {
            saleItem = {};
            saleItem.shortName = item?.shortName;
            saleItem.quantity = item?.quantity;
            saleItem.note = item?.note;
            saleItem.variantValues = item?.variantValues;

            if (!isEmpty(item?.itemOptionList)) {
              itemOptions = [];
              item?.itemOptionList?.forEach(function (itemOption) {
                itemOptions.push({ name: itemOption?.name, quantity: itemOption?.quantity });
              });
              saleItem.itemOptionList = itemOptions;
            }
            saleItems.push(saleItem);
          }
        });
      } else {
        saleItems = ticket?.saleItems;
      }

      ticketData.billTitle = "Service Ticket";
      if (ticket?.isBackOrderTicket) {
        ticketData.billTitle = "Backorder Ticket";
      }
      if (!isEmpty(ticket.groupName)) {
        ticketData.billTitle = ticketData?.billTitle + ":" + ticket?.groupName;
      }
      //When reprint is fired, add reprint to the title. When Cancel ticket is printed, print cancel on title.
      if (ticketData.printStatus === "Completed") {
        ticketData.billTitle = ticketData?.billTitle + " (Reprint)";
      } else if (ticket.ticketStatus === "Cancelled") {
        ticketData.billTitle = ticketData?.billTitle + " (Cancelled)";
      } else if (saleData.saleStatus === "Cancelled") {
        ticketData.billTitle = ticketData?.billTitle + " (Cancelled)";
      } else if (auto !== true) {
        ticketData.billTitle = ticketData?.billTitle + "(Manual Print)";
      }
      if (!(createdBy && !isEmpty(createdBy?.date))) {
        createdBy = {};
        createdBy.date = moment().tz(store.getState()?.businessStore?.businessData?.timeZone?.zoneId).format();
        ticket.createdBy = createdBy;
      }
      ticketData.itemCount = saleItems?.length;
      ticketData.serviceLabel = saleData?.serviceLabel;
      if (saleData.deliveryInfo) {
        ticketData.deliveryInfo = { mode: saleData?.deliveryInfo?.mode, deliveryDate: saleData?.deliveryInfo?.deliveryDate };
      }
      if (!ticketData?.serviceLabel || isEmpty(ticketData.serviceLabel.label)) {
        contactInfo = saleData?.customerInfo?.contactInfo || {};
        if (contactInfo?.name?.firstName && ticketData?.serviceLabel) {
          const serviceLabel = structuredClone(ticketData?.serviceLabel);
          serviceLabel["label"] = contactInfo?.name?.firstName
          ticketData.serviceLabel = serviceLabel;
        }
        if (saleData?.deliveryInfo) {
          contactInfo = saleData?.deliveryInfo?.contactInfo || {};
          ticketData.deliveryInfo.contactInfo = { name: contactInfo?.name };
        } else if (saleData.customerInfo) {
          ticketData.customerInfo = { contactInfo: { name: contactInfo?.name } };
        }
      }

      ticketData.updatedBy = ticket?.updatedBy || ticket?.createdBy;
      ticketData.saleBy = saleData?.saleBy;
      ticketData.note = saleData?.note;
      ticketData.showChannelName = saleData?.showChannelName;
      if (!printTemplate.hideChannelInfo) {
        ticketData.showChannelName = true;
      }
      ticketData.channelName = saleData?.channelName;
      ticketData.channelDefId = saleData?.channelDefId;
      ticketData.showNote = true;
      ticketData.groupName = ticket?.groupName;
      ticketData.isAggregatedTicket = ticket?.isAggregatedTicket;
      ticketData.isTransferTicket = ticket?.isTransferTicket;
      ticketData.isBackOrderTicket = ticket?.isBackOrderTicket;
      ticketData.billNumber = ticketData?.ticketNumber;
      ticketData.saleItems = saleItems;
      ticketData.tags = saleData?.tags;
      if (ticket.ticketCancelReason) {
        ticketData.ticketCancelReason = ticket?.ticketCancelReason;
      }
      if (!isEmpty(ticketData?.groupName) && !isEmpty(groups)) {
        groups?.forEach(function (group) {
          if (group.name === ticketData?.groupName) {
            if (group?.showBillBarcode) {
              ticketData.billNumberBarcode = saleData?.billNumber || saleData?.offlineNumber;
            }

            if (group?.pinSupport) {
              ticketData.pinSupport = true;
            }

            if (!group?.showItemBarcode) {
              ticketData?.saleItems?.forEach(function (saleItem) {
                // if(saleItem && saleItem.barCode) delete saleItem?.barCode;
              });
            }

            if (!isEmpty(group?.footer)) {
              ticketData.billFooter = group?.footer;
            }
          }
        });
      }
      if (saleData?.billHeader) {
        billHeader = {};
        if (isEmpty(saleData?.billHeader?.brandName)) {
          billHeader.businessName = saleData.billHeader?.businessName;
        }
        billHeader.brandName = saleData?.billHeader?.brandName;
      }
      ticketData.billHeader = billHeader;

      if (printTemplate?.hideBusinessInfo) {
        delete ticketData?.billHeader;
      }

      if (printTemplate?.hideChannelInfo) {
        delete ticketData?.showChannelName;
        delete ticketData?.channelName;
      }

      if (printTemplate?.hideServiceLabelInfo) {
        delete ticketData?.serviceLabel;
      }

      if (printTemplate?.hideCustomerInfo) {
        delete ticketData?.customerInfo;
        delete ticketData?.deliveryInfo?.contactInfo
      }

      if (printTemplate?.hideDeliveryInfo) {
        delete ticketData?.deliveryInfo;
      }

      if (printTemplate?.hideSourceInfo) {
        delete ticketData?.sourceInfo;
      }

      if (printTemplate?.hideSaleByAndDate) {
        delete ticketData?.updatedBy;
        delete ticketData?.saleBy;
      }

      ticketDataArr.push(ticketData);
    });
  return ticketDataArr;
}

//======================================

export function printSaleTickets(sale, tickets = [], retryCount, isManualPrint = false) {
  let channelData = getChannelDefData(sale?.channelDefId);
  //handle adhoc table case
  if (
    !isManualPrint &&
    channelData?.skipAdhocTicketCreation &&
    sale?.serviceLabel?.isAdhoc
  ) {
    return false;
  }
  let printDeviceId = store.getState().catalogStore?.posSettings?.tickets?.printDeviceId,
    pollingChannles = store.getState().catalogStore?.posSettings?.tickets?.pollingChannelDefIds || [];
  if (!!printDeviceId && !isManualPrint && pollingChannles?.includes(sale?.channelDefId)) {
    if (printDeviceId === getLocalStorage(LOCALSTORAGE_KEYS.deviceIdentifier)) {
      pollForTickets();
      // callWorker()
    } else {
      // Do nothing. ticket will be printed from polling device
    }
    //Signifies that tickets will print from polling.
    return true;
  } else {
    let ticketsToPrint = []
    if (!sale || isEmpty(sale?.tickets)) {
      return;
    }
    let pendingTickets = 0;
    if (sale.tickets?.length) {
      sale?.tickets?.forEach(function (saleTicket) {
        if (saleTicket?.printStatus === 'Pending' && !isManualPrint) {
          pendingTickets++;
          ticketsToPrint.push(saleTicket);
        } else if (isManualPrint) {
          pendingTickets++
          ticketsToPrint.push(saleTicket);
        }
      });
    }

    let salePrintParams;
    if (sale?.fulfillmentStatus === 'Accepted' &&
      sale?.tickets?.length === pendingTickets &&
      !isEmpty(sale?.printLog) &&
      sale?.printLog?.length === 1 &&
      sale?.printLog[0]?.auto === true &&
      store.getState().catalogStore?.posSettings &&
      store.getState().catalogStore?.posSettings?.tickets?.printDeviceId === getLocalStorage('deviceIdentifier')) {
      var printerRecord = store.getState().printerStore?.defaultPrinter || {};
      // var printerRecord = _.getStore('printer_store').findRecord('mid', defaultPrinterId);
    }

    if (!isEmpty(ticketsToPrint)) {
      // _.Viewport.fireEvent('printtickets', Rista.CommonHelper.getTickets(sale, ticketsToPrint, true), null, salePrintParams);
      let ticketsToPrintArr = getTickets(sale, tickets, true)
      printKOT(ticketsToPrintArr, isManualPrint)
    }
    //Signifies that tickets will not print from polling.
    return false;
  }
}

function updatePrintStatus(params, id) {
  try {
    let url = `${RISTA_API_URL}${RISTA_COMMON_URL}sale/${id}/ticket/printstatus`;
    let xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.setRequestHeader("deviceIdentifier", getLocalStorage("deviceIdentifier"));
    xhr.setRequestHeader("ATOKEN", getLocalStorage("ATOKEN"));
    xhr.send(JSON.stringify(params));
    return new Promise(function (resolve, reject) {
      xhr.onload = function () {
        let response = JSON.parse(xhr.response)
        if ((response?.branchId || response?.tickets) && xhr.status === 200) {
          resolve(xhr.responseText);
          updateAdhocTables(response);
        } else {
          reject;
        }
      };
      xhr.onerror = reject;
    });
  } catch (error) {
    console.log("error", error);
  }
}

export function printSalesummary(saleSummary, printer) {
  let printParams = {
    maxChars: printer?.printWidth ?? 46,
  };
  let printData = window.RL?.salesummaryreport?.getPrintContent(saleSummary, printParams);

  if (isSlave()) {
    let d = prepareLocalServerPrintData(printData);
    if (isElectron()) {
      window.electronAPI.server.post(d);
    } else {
      exec(NW_APP_EVENT_KEYS.server, NW_APP_EVENT_ACTIONS.server.post, d);
    }
  } else {
    if (isAndroid()) {
      sendDataToApp({
        eventName: REACT_NATIVE_APP_EVENTS.printBill,
        data: printData,
        printerDetails: printer,
      })
    } else if (isElectron()) {
      window.electronAPI.printer.print(printData, printer);
    } else {
      exec(NW_APP_EVENT_KEYS.printer, NW_APP_EVENT_ACTIONS.printer.print, [printData, printer]);
    }
  }
  store.dispatch(updateToastInfo({ toastMessage: getErrorMessage("PRINTER_REQUEST_MESSAGE", 'Sales Summary Report'), isToastOpen: true, duration: 2000, direction: { vertical: 'bottom', horizontal: 'right' }, toastType: 'success' }))
}

export function handlePrintData(printContent, printer) {
  if (isSlave()) {
    let d = prepareLocalServerPrintData(printContent);
    if (isElectron()) {
      window.electronAPI.server.post(d);
    } else {
      exec(NW_APP_EVENT_KEYS.server, NW_APP_EVENT_ACTIONS.server.post, d, {});
    }
  } else if (isElectron()) {
    window.electronAPI.printer.print(printContent, printer);
  } else {
    exec(NW_APP_EVENT_KEYS.printer, NW_APP_EVENT_ACTIONS.printer.print, [printContent, printer]);
  }
}

export const handlePrintLogic = (res = {}) => {
  let printer = store.getState().printerStore?.defaultPrinter || {};
  console.log("===isAndroid handlePrintLogic", printer, isPineLabDevice())
  if (printer?.mid || isSlave() || isPineLabDevice()) {
    handlePrintOnClose(res, printer)
  }
  // if (location.pathname === "/new-order")
  printSaleTickets(res, res.tickets || [], 1);
}

function handlePrintOnClose(saleData, printer) {
  const channels = store.getState().catalogStore?.channelDef || [];
  let channelsMap = arrayToMap(channels, "mid");
  let selectedChannelData = channelsMap[getSelectedChannel()?.channelDefId];
  const branchId = store.getState()?.businessStore?.businessData?.branchId;
  selectedChannelData = catalogHelpers.handleChannelVariant(selectedChannelData, branchId);
  printSale(saleData, printer, selectedChannelData?.billPrintCopies, '', true);
}

function prepareLocalServerPrintData(printData = {}, printer = {}) {
  const tid = store.getState().businessStore?.businessData?.branchId;
  printer = { remotePrinterId: "defaultPrinter" };
  const versionNumber = getVersionNumber();
  const isSuitableVersion = !isNaN(versionNumber) && versionNumber >= MIN_NW_APP_VERSION_SUPPORTED.LS_BRIDGE && versionNumber <= NW_APP_LATEST_STABLE_VERSION;
  let message = {
    domain: getMasterDomain(),
    tid: tid,
    // type: 'PRINT',
    type: isSuitableVersion ? 'PRINT_NEW' : 'PRINT',
    data: [printData, printer],
  },
    d = getLSRequestPayloadData('misc', message);
  return d;
}

/**
 *
 * @param printerId
 * @returns if printerId has references
 */
export function checkPrinterReferenceInPosSettings(printerId) {
  if (!printerId) return false;
  let posSettings = store.getState()?.catalogStore?.posSettings || {};
  let hasReferences = false;

  // searching for printer references in posSettings.tickets.groups[i].printers
  if (posSettings.tickets?.groups?.length) {
    for (let groupObj of posSettings.tickets.groups) { // iterating over all the ticket groups
      if (groupObj?.printers?.length) {
        // searching for given printerId in the printers array
        let foundVal = groupObj.printers.find(
          (printerObj) => printerObj?.printerId === printerId);
        hasReferences = !!foundVal;
      }
      if (hasReferences) {
        return true;
      }
    }
  }

  // searching for printer references in itemLabelSettings.printers
  if (posSettings.itemLabelSettings?.printers?.length) {
    // searching for given printerId in the printers array
    let foundVal = posSettings.itemLabelSettings.printers.find(
      (printerObj) => printerObj?.printerId === printerId);
    hasReferences = !!foundVal;
  }
  return hasReferences;
}

/**
 *
 * @returns list of all added printers including network, ble, usb, local printers
 */
export function getAllAddedPrintersList() {
  let networkPrintersList =
    store.getState()?.printerStore?.allPrinters || [],
    blePrintersList = getAddedBlePrintersList(),
    usbPrintersList = [],
    localPrintersList =
      store.getState()?.printerStore?.localPrinters || [];
  if (USBPrinter()?.mid) {
    usbPrintersList = [USBPrinter()];
  }
  let allPrintersList = [
    ...networkPrintersList,
    ...blePrintersList,
    ...usbPrintersList,
    ...localPrintersList,
  ];
  let uniquePrintersList = getUniqueListByKey(allPrintersList || [], "mid");
  return uniquePrintersList;
}

/**
 *
 * @returns list of all added label printers including network, ble, usb, local printers
 */
export function getAllAddedLabelPrintersList() {
  let allLabelPrintersList = getAllAddedPrintersList();
  let labelPrintersList = allLabelPrintersList.filter(
    (printerObj) => printerObj?.enableLabelPrinter === "true"
  );
  return labelPrintersList;
}

/**
 *
 * @param printersList
 * @param includeDefaultPrinter
 * @returns printers list after removing printers not added in current device
 */
export function filterUnavailablePrinters(
  printersList,
  includeDefaultPrinter = false
) {
  if (!printersList?.length) return [];
  let allPrintersList = getAllAddedPrintersList();
  if (includeDefaultPrinter) {
    allPrintersList.push(DEFAULT_PRINTER_OBJ);
  }
  let allPrintersMap = arrayToMap(allPrintersList, "mid") || {};
  let filteredPrintersList = printersList.filter(
    (printerObj) => !!allPrintersMap[printerObj?.mid || printerObj?.printerId]
  );
  return filteredPrintersList;
}

export function printItemLabelTemplate(returnedSale, itemLabelSettings) {
  const printerId =
    store.getState()?.catalogStore?.posSettings?.itemLabelSettings
      ?.printerId?.[0],
    printerObj = {},
    allLabelPrintersList = getAllAddedLabelPrintersList(),
    allLabelPrintersMap = arrayToMap(allLabelPrintersList, "mid") || {},
    printer = allLabelPrintersMap[printerId];

  if (!printer) {
    ToastNotifyError(getErrorMessage("UI_ERR_SELECT_PRINTER_FROM_POS"));
    return;
  }

  printerObj.sale = returnedSale;
  printerObj.itemLabelSettings = itemLabelSettings;
  let printData = window.RL?.bill?.getItemLabelPrintContent(structuredClone(printerObj));

  if (!isEmpty(printData)) {
    for (let printerVal in printData) {
      let printerConfig = allLabelPrintersMap[printerVal];
      let printContent = printData[printerVal];
      console.log("Trying Test -- Label Sticker Print Content = \n", printContent);
      if (isElectron()) {
        window.electronAPI.printer.print(printContent, printerConfig);
      } else {
        exec(NW_APP_EVENT_KEYS.printer, NW_APP_EVENT_ACTIONS.printer.print, [printContent, printerConfig]);
      }
    }
  }
}

async function getPrintDataFromHtml(saleData, printParams, maxChars = 46) {
  const printContent = window.RL?.bill?.getPrintContent(saleData, printParams);
  const prints = printContent.split("<!--SPLIT_BREAK-->");
  const printDataArr = [];
  for await (const printContentPart of prints) {
    if (printContentPart && printContentPart.length > 0) {
      const printData = await htmlToEscPosString(printContentPart, maxChars);
      printDataArr.push(printData);
    }
  }
  return printDataArr;
}

async function htmlToEscPosString(htmlString, maxChars) {
  const { width, height, pixelData } = await renderHtmlStringToPixelData(htmlString, maxChars);
  const rasterCommandBytes = pixelDataToEscPosContent(pixelData, width, height);
  return rasterCommandBytes;
}

function performPrintAction(printData, printer, copies, printFromMaster) {
  console.log('printAction')
  if (printFromMaster) {
    let d = prepareLocalServerPrintData(printData, printer);
    while (copies) {
      if (isElectron()) {
        window.electronAPI.server.post(d);
      } else {
        exec(NW_APP_EVENT_KEYS.server, NW_APP_EVENT_ACTIONS.server.post, d);
      }
      --copies;
    }
  } else {
    while (copies) {
      if (isElectron()) {
        window.electronAPI.printer.print(printData, printer);
      } else {
        exec(NW_APP_EVENT_KEYS.printer, NW_APP_EVENT_ACTIONS.printer.print, [printData, printer]);
      }
      --copies;
    }
  }
}

const renderHtmlStringToPixelData = async (htmlString, maxChars = 46) => {
  // Step 1: Create a temporary element to hold the HTML content
  const tempDiv = document.createElement('div');
  const printerWidthPx = Math.floor(12 * maxChars);
  tempDiv.innerHTML = htmlString;

  // Step 2: Style the element with fixed width for thermal printer
  tempDiv.style.position = 'fixed';
  tempDiv.style.top = '0px';
  tempDiv.style.left = '0px';
  tempDiv.style.width = `${printerWidthPx}px`; // Fixed width for thermal printer
  tempDiv.style.zIndex = '-9999';
  tempDiv.style.visibility = 'visible'; // Ensure it's visible for rendering

  // Step 3: Append to document body so styles are computed
  document.body.appendChild(tempDiv);

  try {

    // Step 4: Convert HTML to Canvas to get image pixel data
    const canvas = await htmlToImage.toCanvas(tempDiv, {
      backgroundColor: '#fff',
      allowTaint: true,        // allow cross-origin images/fonts
      useCORS: true,           // needed if using external fonts
      pixelRatio: 1, // Use 1 for 1:1 pixel mapping
      width: printerWidthPx, // Ensure canvas width matches printer width
      skipFonts: true, // Skip fonts to avoid CORS issues and speed up rendering
    });

    // Step 5: Extract pixel data from canvas
    const ctx = canvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    return {
      width: imageData.width,
      height: imageData.height,
      pixelData: imageData.data
    };
  } catch (error) {
    console.error('Error rendering HTML string to pixel data:', error);
    throw error;
  } finally {
    // Step 6: Clean up - remove the element from DOM after a delay
    setTimeout(() => {
      if (tempDiv.parentNode) {
        document.body.removeChild(tempDiv);
      }
    }, 5000);
  }
};

const pixelDataToEscPosContent = (pixels, width, height, mode = 0) => {
  const escposBytes = [];

  // Initialize printer
  escposBytes.push(0x1B, 0x40); // ESC @

  const widthBytes = Math.ceil(width / 8);
  const xL = widthBytes & 0xFF;
  const xH = (widthBytes >> 8) & 0xFF;
  const yL = height & 0xFF;
  const yH = (height >> 8) & 0xFF;

  // GS v 0
  escposBytes.push(0x1D, 0x76, 0x30, mode, xL, xH, yL, yH);

  for (let y = 0; y < height; y++) {
    for (let xByte = 0; xByte < widthBytes; xByte++) {
      let byte = 0x00;

      for (let bit = 0; bit < 8; bit++) {
        const x = xByte * 8 + bit;
        if (x >= width) continue;

        const idx = (y * width + x) * 4;
        const r = pixels[idx];
        const g = pixels[idx + 1];
        const b = pixels[idx + 2];

        const gray = 0.3 * r + 0.59 * g + 0.11 * b;

        if (gray < 150) { // slightly higher threshold better for receipts
          byte |= 0x80 >> bit;
        }
      }

      escposBytes.push(byte);
    }
  }

  // 🟢 VERY IMPORTANT: Feed paper
  escposBytes.push(0x1B, 0x64, 0x02);

  // 🟢 Optional: Cut paper
  escposBytes.push(0x1D, 0x56, 0x41, 0x10);

  return Uint8Array.from(escposBytes);
};

async function updateQrAndBarcodeData(saleData, printParams) {
  const customQRData = getCustomQRData(
    saleData,
    printParams
  );

  if (customQRData) {
    saleData.billQRCode = await generateQrBase64(customQRData);
  } else if (saleData.url && saleData?.printQRCode) {
    saleData.billQRCode = await generateQrBase64(saleData.url);
  }

  // Generate barcode for Zomato orders
  if (saleData.sourceInfo && saleData.sourceInfo.source === 'zomato' && saleData.sourceInfo.invoiceNumber) {
    saleData.billBarcodeImage = generateBarcodeBase64(saleData.sourceInfo.invoiceNumber);
  }
}

export async function generateQrBase64(text, options = {width: 200, height: 200}) {
  try {
    const qrBase64 = await QRCode.toDataURL(text, options);
    return qrBase64;
  } catch (err) {
    console.error('Error generating QR code:', err);
    return '';
  }
}

export function generateBarcodeBase64(value, options = {}) {
  try {
    const canvas = document.createElement("canvas");

    JsBarcode(canvas, value, {
      format: "CODE128",
      height: options.height || 40,
      displayValue: false,
      textAlign: "center",
      fontSize: options.fontSize || 10,
    });

    return canvas.toDataURL("image/png");
  } catch (err) {
    console.error('Error generating barcode:', err);
    return '';
  }
}

export function getCustomQRData(sale, printParams) {
  const billTemplate = printParams?.billTemplate;

  if (sale?.printQRCode &&
      billTemplate?.qrProviderData &&
      billTemplate.qrProviderData.type === 'snaplion' &&
      billTemplate.qrProviderData.id &&
      billTemplate.qrProviderData.appId &&
      billTemplate.qrProviderData.appSecret) {
      const data = [
          sale.billNumber,
          sale.billRoundedAmount,
          billTemplate.qrProviderData.appId,
          billTemplate.qrProviderData.id //location id
      ].join(',');

      const hash = md5(data + billTemplate.qrProviderData.appSecret);
      return (data + ',' + hash);
  }

  return '';
}

